<app-header></app-header>
<!--div class="modal-content">
    <div class="modal-header">
      <span>My Department</span>
      <button type="button" (click)="closeDialog()" class="button close" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body question-modal-body">    
        <div class="row">
            <div class="col-lg-12 " style="padding:20px;">
                <input pInputText type="text" 
                    (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search"
                    style="height: 30px;" />
            </div>
            <div class="col-lg-12" style="margin-top:5px;">
                <p-table #dt [value]="applnList" dataKey="id"
                    [responsive]="true" styleClass="ui-table-customers" [rowHover]="true" [rows]="10"
                    [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]"
                    [paginator]="true" selectionMode="multiple" [scrollable]="true"
                    currentPageReportTemplate="Displaying &#123;first&#125; to &#123;last&#125; of &#123;totalRecords&#125; entries"
                    [filterDelay]="0" [globalFilterFields]="['applnname']">                   
                    <ng-template pTemplate="body" let-applnList let-rowIndex="rowIndex">
                        <tr class="ui-selectable-row">
                            <td style="width:20%;text-align:left;">
                               <span>{{applnList.applnname}}</span>
                            </td>
                            <td style="width:5%">
                                <label class="container-checkbox">
                                    <input type="checkbox" name="checkbox-list" [(ngModel)]="applnList.selected"
                                        [checked]="applnList.selected == true" ngDefaultControl />
                                    <span class="checkmark"></span>
                                </label>
                            </td>
                    </ng-template>
                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="12" style="text-align:left">No records found.</td>
                        </tr>
                    </ng-template>
                </p-table>
            <!--div class="col-lg-12 col-md-12 col-sm-12 mab-20" style="margin-top:20px;">                 
                <div class="col-lg-12">
                    <div *ngFor="let appln of applnList">
                        <ul class="list-group list-group-flush" style="list-style-type: none;">
                            <li class="applndisplay list-group-item">
                                <div class="col-md-12">
                                <span class="datadisplay">{{appln.applicationname}}</span>                               
                                    <input type="checkbox" name="checkbox-list" [(ngModel)]="appln.selected"
                                        [checked]="appln.selected === true" ngDefaultControl />
                                    <span class="checkmark"></span></div>
                            </li>
                    </ul>
                    <ejs-listview id='sample-list' [dataSource]='data' [fields]='fields' [showCheckBox]='true' [checkBoxPosition]="position" [(ngModel)]='data'></ejs-listview-->
                    <!--/div-->
                <!--/div>
                    <div class="col-lg-12">
                        <div class="row">
                          <div class="form-group col-md-12" style="text-align: center;">                            
                            <button (click)="RemoveSelection()" class="btn btn-sm btn-info button--primary"  style="min-width:130px">
                              Remove Selection
                            </button>      
                            <button (click)="Save()" class="btn btn-sm btn-info button--secondary"  style="min-width:100px">
                              Save
                            </button>
                          </div>            
                        </div>
                      </div>
                    </div-->
    <!--ul>
    <li *ngFor="let appln of applnList; index as i;">
        <label class="container-checkbox">
        {{appln.applicationname}}
        <input type="checkbox" name="checkbox-list" [(ngModel)]="appln.applicationname" ngDefaultControl />
        <span class="checkmark"></span>
        </label>
    </li>
    </ul-->
<!--/div>
</div-->